// extracted by mini-css-extract-plugin
export default {"FormWrapper":"FormWrapper_FormWrapper__71cbV"};